import { render, staticRenderFns } from "./tw_user_left_pannel.vue?vue&type=template&id=49e706b6&scoped=true&"
import script from "./tw_user_left_pannel.vue?vue&type=script&lang=js&"
export * from "./tw_user_left_pannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e706b6",
  null
  
)

export default component.exports